import { Config } from 'scenes/common/types';

export const defaultConfig: Config = {
  underMaintenance: false,
  ccMaintenance: false,
  productsUnderMaintenance: [],
  effectiveEndDate: '',
};
